import 'Shared/mootools';
import 'Shared/translations';
import 'shared-constants';
import 'Shared/global';
import 'Shared/PopupModal';
import 'Shared/ifixit-header-footer';
import Loader from 'Shared/utils/loader';

// Initialize navigation event listeners
Loader.initNavEvents();
